import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection, enderecoSociedadeStep, DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE } from '../../shared/sociedadeSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';
import { SUBUNIDADES_OAB_MS } from '../../shared/subUnidadesOabMs';

const pedidoRegistroLivroDiarioConfig = {
  id: 'pedido_registro_livro_diario',
  nome: 'Pedido de Registro de Livro Diário, Balanço Patrimonial e Balancete',
  descricao: 'Solicitação de registro de livro diário, balanço patrimonial e balancete da sociedade de advogados',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'registroLivroDiario', tipoDocumentoProcesso: 89, name: 'Registro de Livro Diário', description: 'Registro de livro diário da sociedade', required: true },
      { id: 'certidaoNegativaDebito', tipoDocumentoProcesso: 348, name: 'Certidão Negativa de Débito', description: 'Certidão negativa de débito dos sócios junto à OAB/MS', required: true }
    ]
  },

  paymentConfig: {
    amount: 82.00
  },

  protocoloConfig: {
    modeloRequerimento: '238',
    tiposAssunto: '648',
    tipoPedido: '466'
  },

  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'emailProfissional', campoNome: 'EmailComercial' },
        { field: 'subsecaoInscricao', campoNome: 'SubUnidadeAtual' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE
  ),

  tituloConfig: {
    tipoLancamentoId: 39,
    enderecoOrigem: 'sociedadeSimples'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection([
          { type: 'email', name: 'emailProfissional', label: 'E-mail Profissional (para envio de comprovante)', required: true, placeholder: 'email@exemplo.com' },
          { type: 'select', name: 'subsecaoInscricao', label: 'Subseção da sua Inscrição', required: true, placeholder: 'Selecione a subseção', options: SUBUNIDADES_OAB_MS }
        ])
      ]
    },
    enderecoSociedadeStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoRegistroLivroDiarioConfig;
